import { useState, useEffect } from "react";
import { query } from "../../defaults/fetch";
import { message } from "antd";

export const useGetVoucherStatistics = (yearId) => {
  const [loading, setLoading] = useState(false);
  const [statistics, setStatistics] = useState({
    totalVouchersCreated: 0,
    vouchersApproved: 0,
    vouchersPending: 0,
    vouchersAwaitingChecking: 0,
    vouchersRejected: 0,
    vouchersSettled: 0,
    vouchersClosed: 0,
    memosAwaitingVoucherCreation: 0
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!yearId || yearId === 0) {
      setStatistics({
        totalVouchersCreated: 0,
        vouchersApproved: 0,
        vouchersPending: 0,
        vouchersAwaitingChecking: 0,
        vouchersRejected: 0,
        vouchersSettled: 0,
        vouchersClosed: 0,
        memosAwaitingVoucherCreation: 0
      });
      return;
    }

    const fetchStatistics = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await query(`voucher/statistics`, {year: yearId});

        if (response.status === 200 && response.data) {
          setStatistics(response.data);
        } else {
          setError(response.message || "Failed to fetch voucher statistics");
          message.error(response.message || "Failed to fetch voucher statistics");
        }
      } catch (err) {
        setError(err.message || "An error occurred while fetching statistics");
        message.error("Failed to fetch voucher statistics");
      } finally {
        setLoading(false);
      }
    };

    fetchStatistics();
  }, [yearId]);

  return { loading, statistics, error };
};

export const fetchVoucherStatistics = async (yearId) => {
  if (!yearId || yearId === 0) {
    return null;
  }

  try {
    const response = await query(`voucher/statistics?year=${yearId}`);

    if (response.status === 200 && response.data) {
      return response.data;
    } else {
      message.error(response.message || "Failed to fetch voucher statistics");
      return null;
    }
  } catch (err) {
    message.error("Failed to fetch voucher statistics");
    return null;
  }
};
